exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.submit[data-v-72c3c4be] {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 0.8rem;\n  font-size: 0.28rem;\n  line-height: 0.8rem;\n  font-weight: bold;\n}\n.info-row[data-v-72c3c4be] {\n  color: #1aad19;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n", ""]);

// exports
